import * as React from 'react';

interface IToastInterface {
  visible: boolean;
  text: string;
}

export default function Toast(props: IToastInterface) {
  return (
    <div className={`ui-toast ${props.visible ? 'active' : ''}`}>
      <div className="ui-toast-content"><span>{props.text}</span></div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/popup/toast.tsx